<div *ngIf="type === AttachmentType.Picture">
  <img (click)="onPictureClicked()" [appJwtSrc]="pictureUrl" />
</div>

<ng-container *ngIf="type === AttachmentType.Video">
  <ng-container *ngTemplateOutlet="videoTemplate"></ng-container>
</ng-container>

<audio *ngIf="type === AttachmentType.Audio" [appJwtSrc]="audioUrl" controls preload></audio>

<ng-container *ngIf="type === AttachmentType.File">
  <ion-icon name="document"></ion-icon>
  <a *ngIf="fileUrl" (click)="downloadFile()" target="_blank" class="filename">
    {{ fileName || ('attachments/File' | translate) }}
  </a>
  <span *ngIf="!fileUrl" class="filename">{{ fileName }}</span>
</ng-container>

<ng-container *ngIf="type === AttachmentType.Link">
  <div *ngIf="isValid; else invalidAttachment">
    <ion-icon name="link-outline"></ion-icon>
    <a [href]="linkTarget" target="_blank" class="filename">{{ linkLabel }}</a>
  </div>
  <ng-template #invalidAttachment>
    <div class="alc-lighter-text">
      <ion-icon name="link-outline"></ion-icon>
      <span>{{ linkLabel }}</span>
    </div>
  </ng-template>
</ng-container>

<div *ngIf="type === AttachmentType.BZCRichLink || type === AttachmentType.BZCSplittableRichLink" class="rich-link">
  <div class="rich-link-title alc-ellipsis">{{ title }}</div>
  <a [href]="url" (click)="$event.stopPropagation()" target="_blank" class="rich-link-url alc-ellipsis">{{ url }}</a>
</div>

<div *ngIf="type === AttachmentType.ShopProduct" class="shop-product">
  <div>
    <img (click)="onPictureClicked()" [appJwtSrc]="shopProduct.imageUrl" class="product-shop-image" />
  </div>
  <a *ngIf="shopProduct.productUrl" [href]="shopProduct.productUrl" target="_blank" class="product-shop-name">
    {{ shopProduct.name }}
  </a>
  <div *ngIf="!shopProduct.productUrl" class="product-shop-name">{{ shopProduct.name }}</div>
  <div class="product-shop-price">{{ shopProduct.price }}</div>
</div>

<div class="chatbot-message" *ngIf="type === AttachmentType.AgentShortcut && agentShortcut">
  <div class="chatbot-message-title" translate="m/task-process/attach/chatbot-message"></div>
  <div class="chatbot-message-label">{{ agentShortcut?.label || '-' }}</div>
  <div class="chatbot-message-scenario-label">{{ agentShortcut?.scenario_label || '-' }}</div>
</div>

<ng-template #videoTemplate>
  <div *ngIf="!showVideo" (click)="showVideo = true" class="video-placeholder">
    <ion-icon name="play-circle"></ion-icon>
  </div>
  <video *ngIf="showVideo" autoplay muted controls>
    <source [appJwtSrc]="videoUrl" />
  </video>
</ng-template>

<div>
  <ion-button *ngIf="canBeRemoved" (click)="onRemoveClicked()" fill="clear" class="remove-button">
    <ion-icon slot="icon-only" name="close-circle"></ion-icon>
  </ion-button>
</div>
